
const Card1Style = {
  card: {
    boxShadow: 'none'
  },
  parent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  image1: {
    display: 'block',
    top: '0',
    left: '0',
    width: '100px',
    height: '80px',
    marginBottom: '10px'
  },
  title:{
    fontSize:'25px',
    marginBottom: '15px'
  },
  body:{
    fontSize:'18px'
  }
}

export default Card1Style
